import { render, staticRenderFns } from "./image-input.vue?vue&type=template&id=70aa8f42&"
import script from "./image-input.vue?vue&type=script&lang=js&"
export * from "./image-input.vue?vue&type=script&lang=js&"
import style0 from "./image-input.vue?vue&type=style&index=0&id=70aa8f42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports